import { render, staticRenderFns } from "./dictInfo.vue?vue&type=template&id=763b8a22&scoped=true&"
import script from "./dictInfo.vue?vue&type=script&lang=js&"
export * from "./dictInfo.vue?vue&type=script&lang=js&"
import style0 from "./dictInfo.vue?vue&type=style&index=0&id=763b8a22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763b8a22",
  null
  
)

export default component.exports